<div class="modal-header">
  <h4 class="modal-title">{{ isEditMode ? 'Uredi Novico' : 'Dodaj Novico' }}</h4>
  <button type="button" class="close" (click)="closeModal()">&times;</button>
</div>

<div class="modal-body">
  <form>
    <!-- Title -->
    <div class="form-group">
      <label for="title">Naslov</label>
      <input type="text" id="title" class="form-control" [(ngModel)]="newNews.title" name="title" required />
    </div>

    <!-- Summary -->
    <div class="form-group">
      <label for="summary">Povzetek</label>
      <textarea id="summary" class="form-control" [(ngModel)]="newNews.summary" name="summary" required></textarea>
    </div>

    <!-- Body -->
    <div class="form-group">
      <label for="body">Vsebina</label>
      <textarea id="body" class="form-control" [(ngModel)]="newNews.body" name="body" required></textarea>
    </div>

    <!-- Image Upload -->
    <div class="form-group">
      <label for="image">Slika</label>
      <input type="file" id="image" (change)="onImageUploadChanged($event)" />
      <img *ngIf="previewImageSrc" [src]="previewImageSrc" alt="Preview" class="img-thumbnail" />
    </div>

    <!-- Facebook Link -->
    <div class="form-group">
      <label for="facebookLink">Facebook Povezava (lahko prazno)</label>
      <input type="url" id="facebookLink" class="form-control" [(ngModel)]="newNews.facebookLink" name="facebookLink" />
    </div>

    <!-- Author -->
    <div class="form-group">
      <label for="author">Avtor</label>
      <input type="text" id="author" class="form-control" [(ngModel)]="newNews.author" name="author" />
    </div>
  </form>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="closeModal()">Prekliči</button>
  <button class="btn btn-success" (click)="addNews()">{{ isEditMode ? 'Posodobi' : 'Shrani' }}</button>
</div>
